
















import Vue from 'vue'
import UnderlineTextButton from '@/components/Global/UnderlineTextButton.vue'
import { TRACEFY_PRESET_LOCAL_STORAGE_KEY } from '@/components/InstallDevices/constants'

export default Vue.extend({
  name: 'ImportPresetDialog',
  components: { UnderlineTextButton },
  props: {
    presetModalOpened: Boolean,
    isMobile: Boolean,
    presets: Array
  },
  data () {
    return {
      preset: false,
      modalActive: false,
      saveToLocalStorage: false
    }
  },
  methods: {
    close () {
      this.$emit('closePresetModal')
    },
    importPreset () {
      if (this.saveToLocalStorage) {
        window.localStorage.setItem(TRACEFY_PRESET_LOCAL_STORAGE_KEY, this.preset)
      }
      this.$emit('importPreset', this.preset)
      this.close()
    }
  },
  mounted () {
    const presetId = window.localStorage.getItem(TRACEFY_PRESET_LOCAL_STORAGE_KEY)
    if (presetId) {
      this.preset = presetId
      this.importPreset()
      this.saveToLocalStorage = true
    }
  },
  watch: {
    presetModalOpened (val) {
      this.modalActive = val
    },
    saveToLocalStorage (val) {
      if (window.localStorage.getItem(TRACEFY_PRESET_LOCAL_STORAGE_KEY) && !val) {
        window.localStorage.removeItem(TRACEFY_PRESET_LOCAL_STORAGE_KEY)
      }
    }
  }
})
